import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";
import { WidgetGenericDataTable } from "../Widgets/WidgetGenericDataTable";
import { ColumnBase } from "../../Table/ColumnBase";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { PopupCloseType } from "../../PagePopup";


export class WidgetGenericDataTableColumn implements ITableColumn {
    columnType?: string;
    type: TableColumnTypes;
    headerText?: string;
    headerElement?: HTMLElement;
    dataField?: string;
    width?: number;
    defaultWidth?: string;
    number: number;
    align?: TableColumnAlign;
    decimals?: number;
    htmlEncode?: boolean;
    useTime?: boolean;
    useAvatar?: boolean;
    sortAsc?: boolean;
    isSortable?: boolean;
    cssClass?: string;
    toolTip?: string;
    fireOnCellClick?: boolean;
    headerCssClass?: string;
    fixedWidth?: string;
    isEditLink?: boolean;
    isEditable?: boolean;
    isDisabled?: boolean;
    isFilterable?: boolean;
    isSizeable?: boolean;
    sourceName?: string;
    sourceField?: string;
    editType?: EditTypes;
    visibilityField?: string;
    prohibitRowClick?: boolean;
    inhaltText?: string;
    colorField?: string;
}

export type WidgetGenericDataTableComponentProps = {
    widget: WidgetGenericDataTable;
    title: LanguageString;
    apiUrl?: string;
    jsonData?: string;
    availableColumns: string;
    rowClickUrl?: string;
    fixedLayout?: boolean;
    settingsName?: string;
    noClickAction?: boolean;
}

export class WidgetGenericDataTableComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetGenericDataTableComponentProps;
    table: MsoTable;
    availableColumns: WidgetGenericDataTableColumn[];
    //activeColumns: ITableColumn[];

    constructor(props: WidgetGenericDataTableComponentProps) {
        super(props);
    }

    public element: HTMLElement;
    private getElement = () => {
        return <div className="widget Background-Blur-90-MSO widget-generic-data-table">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
                {/*<div>Button Spalten bearbeiten hier</div>*/}
            </div>
            <div className="content-row">
                <div className="mso-table">
                    {this.renderTable()}
                </div>
            </div>
        </div>;
    }

    loadAndCreate = () => {
        if (this.props.apiUrl) {
            $.ajax({
                url: app.resolveUrl(this.props.apiUrl),
                method: "GET",
                success: (response) => {

                    console.log(response);

                    if (Array.isArray(response)) {
                        this.table.createAll(this.availableColumns as ITableColumn[], response, "widget_generic_data_test", "id", true, false, null, this.props.rowClickUrl, true);
                    } else {
                        console.log(response);
                    }
                },
                error: (err) => {
                    console.log(err);
                }
            });
        } else {
            // Do nothing
        }

    }

    renderTable(): HTMLElement {

        let rootId = "widget_" + app.createGuid();
        let div: HTMLElement = <div id={rootId} className="mso-table" ></div >;

        if (this.props.availableColumns) {
            this.availableColumns = [];
            try {
                this.availableColumns = JSON.parse(this.props.availableColumns);
                this.availableColumns.forEach(c =>
                    c.type = TableColumnTypes[c.columnType]
                );
            } catch (err) {
                console.log(err);
            }
        } else {
            this.availableColumns =
                [
                    { type: TableColumnTypes.Date, dataField: "zieltermin", cssClass: "cs-fd", number: 1, headerText: "Zieltermin" },
                    { type: TableColumnTypes.String, dataField: "abteilung", cssClass: "cs-fd", number: 1, headerText: "Abteilung" },
                    { type: TableColumnTypes.String, dataField: "statusName", cssClass: "cs-fd", number: 1, headerText: "Status" },
                    { type: TableColumnTypes.Bool, dataField: "beantwortet", cssClass: "cs-fd", number: 1, headerText: "Beantwortet" },
                    { type: TableColumnTypes.Double, dataField: "anzahlNein", cssClass: "cs-fd", number: 1, headerText: "Anzahl Nein" },
                    { type: TableColumnTypes.Double, dataField: "version", cssClass: "cs-fd", number: 1, headerText: "Version" },
                ];
        }


        this.table = new MsoTable(div, {
            loadOnCreate: false,
            enableScroll: true,
            enableSort: true,
            enableFilterPopup: true,
            fixedLayout: this.props.fixedLayout,
            fixedHeader: true,
            editType: this.props.noClickAction ? EditTypes.None : EditTypes.MeasureFullscreen,
            viewIndex: 42,
            rowClickUrl: this.props.rowClickUrl,
            rowClickUrlUsePopup: true,
            onCloseEditPopup: this.reloadTable,
            settingsName: this.props.settingsName,

        });

        this.loadAndCreate();

        return div;

    }

    private reloadTable = (reason: PopupCloseType, id: number) => {

        if (this.props.apiUrl) {
            $.ajax({
                url: app.resolveUrl(`${this.props.apiUrl}/${id}`),
                method: "GET",
                success: (response) => {

                    if (Array.isArray(response)) {
                        if ((response as []).length > 0) {
                            this.table.flexTable.updateRow(response[0]);
                        } else {
                            this.table.removeRow[id];
                        }
                    } else {
                        console.log(response);
                    }
                },
                error: (err) => {
                    console.log(err);
                }
            });
        } else {
            // Do nothing
        }

    }


    //renderGridViewSelect(): HTMLElement {
    //    let div = <div></div>;
    //    $.get(app.resolveUrl(`~/api/gridView/getClientGridView/${this.props.viewType}/42`), (model: IClientGridView) => {
    //        new GridViewSelect(div, model, true).onViewChanged = () => {
    //            this.props.widget.recreate();
    //        };
    //    });
    //    return div;
    //}

    public render(): HTMLElement {
        this.element = this.getElement();
        this.props.widget.setGridPosition();
        return this.element;
    }
}